import "../../assets/css/RightPanel.css";
import TableData from "./TableData";
import UserActions from "../../actions/UserActions";
import { Space, Button } from "antd";
import { ADMIN_SERVER_API } from "../../AdminConstants";
import MakeAccountOwnerButton from "./MakeAccountOwnerButton";

const AdminToolUserTab = (props) => {
  const {
    userData,
    userColumns,
    columnWithDelete,
    handleDelete,
    accountData,
    customerResData,
    setCustomerResData,
    accountOwnerDataRef,
    fetchUserData,
    userFormFields,
  } = props;

  return (
    <Space className="w-100" direction="vertical">
      <UserActions osyncIds={accountData} fetchUserData={fetchUserData} formFields={userFormFields} />
      <TableData
        customersData={userData}
        columns={columnWithDelete(
          userColumns,
          handleDelete,
          "user",
          userData,
          "Delete",
          [
            {
              title: "View page",
              dataIndex: "viewPage",
              fixed: "left",
              render: (_, record) => {
                return (
                  <Button
                    onClick={() => {
                      const params = new URLSearchParams();
                      params.append("osyncId", record.osyncId);
                      params.append("leftServiceId", accountData["Left Service ID"]);
                      params.append("companyId", accountData["Remote Identifier"].split("_")[1]);
                      params.append("userId", record.remoteUserId);
                      window.open(ADMIN_SERVER_API + "customer-redirect" + "?" + params.toString(), "_blank");
                    }}
                  >
                    View page
                  </Button>
                );
              },
              key: "viewPage",
            },
          ],
          MakeAccountOwnerButton,
          { accountOwnerDataRef, customerResData, setCustomerResData },
          (record) => {
            return record?.roleId !== 11;
          },
        )}
        rowWise={false}
      />
    </Space>
  );
};

export default AdminToolUserTab;
